import { Component, OnInit, ViewChild, Input, Output, EventEmitter, TemplateRef, } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-mat-data-grid',
  templateUrl: './mat-data-grid.component.html',
  styleUrls: ['./mat-data-grid.component.css']
})
export class MatDataGridComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // DATA SOURCE
  _dataSource: any;
  dataCopy: Array<any>;
  @Input() set dataSource(data: Array<any>){
    console.log('source change');
    this.dataCopy = JSON.parse(JSON.stringify(data));
    this._dataSource = new MatTableDataSource(data);
    this._dataSource.sort = this.sort;

    // change sortingDataAccessor to sort by nested object values.
    this._dataSource.sortingDataAccessor = (item, property) => {
      if(property.indexOf(".") != -1){
        const keys = property.split(".");
        for(var i=0; i<keys.length; i++){
          if(item.hasOwnProperty(keys[i])){
            item = item[keys[i]];
          }else{
            return null;
          }
        }
        return item;
      }
      return item[property];
    };

    // change filterPredicate to search by nested object values.
    this._dataSource.filterPredicate = (data, filter: string) => {
      const buildDataString = function(obj): string { 
        var returnString = "";
        try{
          Object.keys(obj).forEach(key => {
            if(typeof obj[key] === 'object'){
              returnString += buildDataString(obj[key]);
            }else{
              returnString += String(obj[key]).toLowerCase();
            }
          });
        }catch{
          return returnString;
        }
        return returnString;
      };
      const dataStr = buildDataString(data);
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };
    this._dataSource.paginator = this.paginator;
    this.applyFilter();
  }
  
  @Output() dataSourceChange = new EventEmitter<any>();
  @Output() itemChange = new EventEmitter<any>();

  // COLUMN CONTROL
  _displayedColumns = [];
  definedColumns = [];
  @Input() columnNames: Array<any> = [];                          //alternative way of setting the header values.
  @Input() set displayedColumns(columns:Array<string>){           //array of keys
    this.definedColumns = columns;
    this._displayedColumns = JSON.parse(JSON.stringify(this.definedColumns));
    if(this._showButtons){
      this.showGridButtons();
    }else{
      this.hideGridButtons();
    }
  }
  @Input() columnFormatters = {}                                  //Format functions for each column to prettify data

  // FORM
  @Input() formValid: boolean = true;

  // TABLE CONFIG
  @Input() searchBarEnabled: boolean = true;                      //Whether or not to display the search bar for filtering data
  @Input() header: TemplateRef<HTMLElement> = null;               //template containing content to display at the top w/ search input and add button
  @Input() headerTwo: TemplateRef<HTMLElement> = null;            //secondary header to display under the search header. a good place to display messages
  @Input() objectBluePrint: any = {};                             //default javascript object for when creating a new row.
  @Input() editDefinition: any = {};                              //object containing a key for each column that can be edited. the value should be a template with form elements for updating the column value
  @Input() displayDefinition: any = {};                           //object containing a key for each colum that has a custom display template. lets you modify how rows not in edit mode appear
  @Input() pageSizeOptions: Array<number> = [5, 10, 25, 50];      //paginator config for number of rows to display
  _buttonConfig = {                                               //controls which buttons exist, and their event output when clicked
    create: {show: false, output: "create", funcEnabled: true},
    edit: {show: true, output: "edit", funcEnabled: true},
    delete: {show: true, output: "delete", funcEnabled: true},
    confirm: {show: true, output: "confirm", funcEnabled: true},
    cancel: {show: true, output: "cancel", funcEnabled: true}
    //custom: {output: 'custom', label: 'custom', template: HTMLtemplate}                 //example for custom button
  }
  customButtonKeys = [];
  @Input() set buttonConfig(config: any){
    let keys = Object.keys(config);
    for(let i=0; i<keys.length; i++){
      if(this._buttonConfig[keys[i]]){
        //overwrite existing config values
        Object.assign(this._buttonConfig[keys[i]], config[keys[i]]);
      }else{
        //add new config values
        this._buttonConfig[keys[i]] = config[keys[i]];
        this.customButtonKeys.push(keys[i]);
      }
    }
  }

  _showButtons = true;
  @Input() set showButtons(show:boolean){
    this._showButtons = show;
    if(show){
      this.showGridButtons();
    }else{
      this.hideGridButtons();
    }
  }

  // EVENTS
  @Output() buttonClick = new EventEmitter<any>();              //emits whenever a table button is clicked. event contains row if any, and the buttons output string

  // OTHER
  mouseIndex = -1;
  editIndex = -1;
  filterValue = "";
  touchedDataElement: any = {};
  isNewRow: boolean = false;
  dataIndex: number = -1;

  constructor() { }

  ngOnInit(): void {}

  sortLog(event:any){
    console.info(event);
  }

  hideGridButtons(){
    let index = this._displayedColumns.indexOf("buttons");
    if(index != -1){
      this._displayedColumns.splice(index, 1);
    }
  }

  showGridButtons(){
    let index = this._displayedColumns.indexOf("buttons");
    if(index == -1){
      this._displayedColumns.push("buttons");
    }
  }

  ngAfterViewInit(){
    this._dataSource.sort = this.sort;
    this._dataSource.paginator = this.paginator;
  }

  performSearch(){
    this.applyFilter();
    if (this._dataSource.paginator) {
      this._dataSource.paginator.firstPage();
    }
  }

  applyFilter(){
    this._dataSource.filter = this.filterValue.trim().toLowerCase();
    // this._dataSource.filter = this.filterValue.trim();
  }

  editRow(index: number, element: any){
    if(this._buttonConfig.edit.funcEnabled){
      this.editIndex = index;
      this.dataIndex = this._dataSource.data.indexOf(element)
      if(this.dataIndex != -1){
        this.touchedDataElement = JSON.parse(JSON.stringify(this._dataSource.data[this.dataIndex]));
      }else{
        console.error("index not found for ", element);
        this.editIndex = -1;
      }
    }
    this.buttonClick.emit({button:this._buttonConfig.edit.output, item: element});
  }

  deleteRow(index: number, element: any){
    if(this._buttonConfig.delete.funcEnabled){
      if(confirm("Are you sure you want to delete this item?")){
        this.dataIndex = this._dataSource.data.indexOf(element)
        this._dataSource.data.splice(this.dataIndex, 1);
        this.applyFilter();
      }
    }
    this.dataSourceChange.emit(this._dataSource.data);
    this.buttonClick.emit({button: this._buttonConfig.delete.output, item: element});
  }

  createRow(){
    if(this._buttonConfig.create.funcEnabled){
      this.isNewRow = true;
      this.touchedDataElement = JSON.parse(JSON.stringify(this.objectBluePrint))

        this._dataSource.data.splice(0, 0, this.touchedDataElement);
        this.applyFilter()

      this.dataIndex = 0;
      this.filterValue = "";
      this.performSearch();
      this.editIndex = 0;
    }
  }

  confirmChange(){
    if(this._buttonConfig.confirm.funcEnabled){
      if(!this.isNewRow){
        this._dataSource.data[this.dataIndex] = this.touchedDataElement;
        this.applyFilter()
      }
      this.editIndex = -1;
      this.dataIndex = -1;
      this.isNewRow = false;
    }
    this.dataSourceChange.emit(this._dataSource.data);
    this.itemChange.emit(this.touchedDataElement);
    this.buttonClick.emit({button: this._buttonConfig.confirm.output, item: this.touchedDataElement});
  }

  cancelChange(){
    if(this._buttonConfig.cancel.funcEnabled){
      if(this.isNewRow){
        this._dataSource.data.shift();
        this.applyFilter();
      }
      this.editIndex = -1;
      this.dataIndex = -1;
      this.isNewRow = false;
    }
  }

  copyText(element, column){
    const text = this.getColumnValue(element, column, this.columnFormatters[column]);
    console.log(`copied ${text}`);
    navigator.clipboard.writeText(text)
  }

  getColumnValue(element:any, path:string, formatter:Function = (value) => {return value}){
    let keys = path.split(".");
    while(keys.length > 0){
      var key = keys.splice(0,1)[0];
      if(element.hasOwnProperty(key)){
        if(keys.length == 0){
          return formatter(element[key]);
        }else{
          element = element[key];
        }
      }
    }
    return "";
  }

}
